import { FilterMeta } from 'proto/Search/FilterMeta';
import { RequestFilter } from 'proto/Search/KiFilter/RequestFilter';

export interface RequestFilterData
    extends Omit<RequestFilter, 'hasCount' | 'count' | 'minPrice'>,
        Partial<FilterMeta> {
    isSelectable: boolean;
}

interface BaseFilterGroupData {
    label: string;
    multi?: boolean;
    minLogic?: boolean;
}

export interface RequestFilterGroupData extends BaseFilterGroupData {
    refKey: string;
}

export interface FilterGroupData extends BaseFilterGroupData {
    filters: RequestFilterData[];
    isVisible: boolean;
}

export enum SearchState {
    Active = 'Active',
    Inactive = 'Inactive',
    Spinner = 'Spinner',
}

export interface ErrorMessage {
    title: string;
    hint?: string;
}

export type FilterData = Record<string, FilterGroupData>;
